module.exports = __webpack_public_path__ + "static/media/Banner-beneficios-movil.b10894da.jpg";